import styled from 'styled-components';
import { GhostButton } from 'ui/button';
import { EmptyState } from 'ui/emptyState';
import { FlexSpacer } from 'ui/flexSpacer';
import { FormField } from 'ui/formField';
import { GridRow, HeaderGridRow } from 'ui/indexPages/tables/grid';
import { PaginationFooter } from 'ui/paginationFooter';
import { Select } from 'ui/selectv2/Select';
import { button, spacing } from 'ui/theme';

/** Layout */
export const GRID_LAYOUT = `2fr 1fr 2fr 1fr ${spacing.x10}`;

export const StyledHeaderRow = styled(HeaderGridRow)`
  gap: ${spacing.double};
`;

export const StyledTableRow = styled(GridRow)`
  gap: ${spacing.double};
  align-items: flex-start;
`;

/** Empty states */
export const StyledEmptyState = styled(EmptyState)`
  padding: ${spacing.double};
`;

export const SpinnerFlexSpacer = styled(FlexSpacer)`
  min-height: 20vh;
  padding: ${spacing.double};
`;

/** Cells */
export const Cell = styled(FlexSpacer)`
  ${button}
  padding: ${spacing.half} 0;
`;

/** Inputs */
export const StyledFormField = styled(FormField)`
  width: 100%;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
`;

export const ActionButton = styled(GhostButton)`
  visibility: hidden;

  ${StyledTableRow}:hover & {
    visibility: visible;
  }
`;

/** Pagination */
export const StyledPaginationFooter = styled(PaginationFooter)`
  padding-bottom: ${spacing.base};
`;
